module.exports = __webpack_public_path__ + "public/images/opengraph.760f8cbcac0b356cef5035e3ccc2da81.jpg";